export const useHandleBar = (isPopupOpen: Ref<boolean>, onClose: () => void, popupRef: Ref<HTMLElement | null>) => {
  const isDragging = ref(false);
  const dragStartY = ref(0);
  const dragDistanceY = ref(0);

  const VELOCITY_THRESHOLD = 0.5;
  let dragStartTime = 0;

  const dragPopupStyle = computed(() => {
    if (!isPopupOpen) return {};

    const translateY = Math.max(0, dragDistanceY.value);
    return {
      transform: `translateY(${translateY}px)`,
    };
  });

  const startDrag = (event: MouseEvent | TouchEvent) => {
    isDragging.value = true;
    dragDistanceY.value = 0;
    dragStartTime = Date.now();

    const clientY = 'touches' in event ? event.touches[0].clientY : event.clientY;
    dragStartY.value = clientY;

    window.addEventListener('mousemove', onDrag);
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchmove', onDrag, { passive: true });
    window.addEventListener('touchend', endDrag);
  };

  const onDrag = (event: MouseEvent | TouchEvent) => {
    if (!isDragging.value) return;

    const clientY = 'touches' in event ? event.touches[0].clientY : event.clientY;
    dragDistanceY.value = clientY - dragStartY.value;
  };

  const endDrag = () => {
    if (!isDragging.value) return;

    isDragging.value = false;

    const elapsedTime = Date.now() - dragStartTime;
    const velocity = dragDistanceY.value / elapsedTime;

    const popupHeight = popupRef.value?.offsetHeight ?? 0;
    const isOverHalf = dragDistanceY.value > popupHeight / 2;

    const isClose = isOverHalf || velocity > VELOCITY_THRESHOLD;

    if (isClose) {
      onClose();
    } else {
      dragDistanceY.value = 0;
    }

    window.removeEventListener('mousemove', onDrag);
    window.removeEventListener('mouseup', endDrag);
    window.removeEventListener('touchmove', onDrag);
    window.removeEventListener('touchend', endDrag);
  };

  watch(
    () => isPopupOpen,
    (newVal) => {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
        dragDistanceY.value = 0;
      }
    }
  );

  onUnmounted(() => {
    document.body.style.overflow = '';
    window.removeEventListener('mousemove', onDrag);
    window.removeEventListener('mouseup', endDrag);
    window.removeEventListener('touchmove', onDrag);
    window.removeEventListener('touchend', endDrag);
  });

  return {
    isDragging,
    dragPopupStyle,
    startDrag,
  };
};
